import * as React from "react"
import {Skeleton} from "@mui/material";

import {useUserApp} from "@hooks";
import { TitleWithPopover, AppTableSeeker } from "@components";
import {isLoadingCommonFilters} from "@signals";
import {sellerDetailsData} from "../@signals";
import {retailerColumn, dispersionColumn, offersColumn, stockColumn, sellerColumn, productsColumn, buyBoxColumn, sellerCountryColumn} from "./columns"
import MarketplacesSellerProductDetailsToggleButton from "../DetailsToggle";


const HEIGHT = 500

export default function MarketPlacesSellerDetailsTable() {
	const { userUseRRSP } = useUserApp()
	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!sellerDetailsData.value.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Marketplaces - Sellers details" />}
		data={sellerDetailsData.value}
		columns={[
			retailerColumn(),
			sellerColumn(),
			...sellerCountryColumn(),
			offersColumn(),
			productsColumn(),
			...userUseRRSP ? [dispersionColumn()] : [],
			buyBoxColumn(),
			stockColumn()
		]}
		options={{
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPageOptions: [5, 10],
			customToolbar: () => <MarketplacesSellerProductDetailsToggleButton />
		}}
	/>
}